import {useContext, createElement, createContext, forwardRef} from "react";
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i2 = 0; i2 < document.styleSheets.length; i2++) {
    if (document.styleSheets[i2].ownerNode === tag) {
      return document.styleSheets[i2];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var c = "comm";
var n = "rule";
var t = "decl";
var i = "@import";
var p = "@keyframes";
var k = Math.abs;
var d = String.fromCharCode;
var g = Object.assign;
function m(e2, r2) {
  return (((r2 << 2 ^ z(e2, 0)) << 2 ^ z(e2, 1)) << 2 ^ z(e2, 2)) << 2 ^ z(e2, 3);
}
function x(e2) {
  return e2.trim();
}
function y(e2, r2) {
  return (e2 = r2.exec(e2)) ? e2[0] : e2;
}
function j(e2, r2, a2) {
  return e2.replace(r2, a2);
}
function C(e2, r2) {
  return e2.indexOf(r2);
}
function z(e2, r2) {
  return e2.charCodeAt(r2) | 0;
}
function A(e2, r2, a2) {
  return e2.slice(r2, a2);
}
function O(e2) {
  return e2.length;
}
function M(e2) {
  return e2.length;
}
function S(e2, r2) {
  return r2.push(e2), e2;
}
function q(e2, r2) {
  return e2.map(r2).join("");
}
var B = 1;
var D = 1;
var E = 0;
var F = 0;
var G = 0;
var H = "";
function I(e2, r2, a2, c2, n2, t2, s) {
  return {
    value: e2,
    root: r2,
    parent: a2,
    type: c2,
    props: n2,
    children: t2,
    line: B,
    column: D,
    length: s,
    return: ""
  };
}
function J(e2, r2) {
  return g(I("", null, null, "", null, null, 0), e2, {
    length: -e2.length
  }, r2);
}
function K() {
  return G;
}
function L() {
  G = F > 0 ? z(H, --F) : 0;
  if (D--, G === 10)
    D = 1, B--;
  return G;
}
function N() {
  G = F < E ? z(H, F++) : 0;
  if (D++, G === 10)
    D = 1, B++;
  return G;
}
function P() {
  return z(H, F);
}
function Q() {
  return F;
}
function R(e2, r2) {
  return A(H, e2, r2);
}
function T(e2) {
  switch (e2) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function U(e2) {
  return B = D = 1, E = O(H = e2), F = 0, [];
}
function V(e2) {
  return H = "", e2;
}
function W(e2) {
  return x(R(F - 1, ee(e2 === 91 ? e2 + 2 : e2 === 40 ? e2 + 1 : e2)));
}
function Y(e2) {
  while (G = P())
    if (G < 33)
      N();
    else
      break;
  return T(e2) > 2 || T(G) > 3 ? "" : " ";
}
function _(e2, r2) {
  while (--r2 && N())
    if (G < 48 || G > 102 || G > 57 && G < 65 || G > 70 && G < 97)
      break;
  return R(e2, Q() + (r2 < 6 && P() == 32 && N() == 32));
}
function ee(e2) {
  while (N())
    switch (G) {
      case e2:
        return F;
      case 34:
      case 39:
        if (e2 !== 34 && e2 !== 39)
          ee(G);
        break;
      case 40:
        if (e2 === 41)
          ee(e2);
        break;
      case 92:
        N();
        break;
    }
  return F;
}
function re(e2, r2) {
  while (N())
    if (e2 + G === 47 + 10)
      break;
    else if (e2 + G === 42 + 42 && P() === 47)
      break;
  return "/*" + R(r2, F - 1) + "*" + d(e2 === 47 ? e2 : N());
}
function ae(e2) {
  while (!T(P()))
    N();
  return R(e2, F);
}
function ce(e2) {
  return V(ne("", null, null, null, [""], e2 = U(e2), 0, [0], e2));
}
function ne(e2, r2, a2, c2, n2, t2, s, u, i2) {
  var f = 0;
  var o = 0;
  var l = s;
  var v = 0;
  var h = 0;
  var p2 = 0;
  var b = 1;
  var w = 1;
  var $ = 1;
  var k2 = 0;
  var g2 = "";
  var m2 = n2;
  var x2 = t2;
  var y2 = c2;
  var z2 = g2;
  while (w)
    switch (p2 = k2, k2 = N()) {
      case 40:
        if (p2 != 108 && z2.charCodeAt(l - 1) == 58) {
          if (C(z2 += j(W(k2), "&", "&\f"), "&\f") != -1)
            $ = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        z2 += W(k2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        z2 += Y(p2);
        break;
      case 92:
        z2 += _(Q() - 1, 7);
        continue;
      case 47:
        switch (P()) {
          case 42:
          case 47:
            S(se(re(N(), Q()), r2, a2), i2);
            break;
          default:
            z2 += "/";
        }
        break;
      case 123 * b:
        u[f++] = O(z2) * $;
      case 125 * b:
      case 59:
      case 0:
        switch (k2) {
          case 0:
          case 125:
            w = 0;
          case 59 + o:
            if (h > 0 && O(z2) - l)
              S(h > 32 ? ue(z2 + ";", c2, a2, l - 1) : ue(j(z2, " ", "") + ";", c2, a2, l - 2), i2);
            break;
          case 59:
            z2 += ";";
          default:
            S(y2 = te(z2, r2, a2, f, o, n2, u, g2, m2 = [], x2 = [], l), t2);
            if (k2 === 123)
              if (o === 0)
                ne(z2, r2, y2, y2, m2, t2, l, u, x2);
              else
                switch (v) {
                  case 100:
                  case 109:
                  case 115:
                    ne(e2, y2, y2, c2 && S(te(e2, y2, y2, 0, 0, n2, u, g2, n2, m2 = [], l), x2), n2, x2, l, u, c2 ? m2 : x2);
                    break;
                  default:
                    ne(z2, y2, y2, y2, [""], x2, 0, u, x2);
                }
        }
        f = o = h = 0, b = $ = 1, g2 = z2 = "", l = s;
        break;
      case 58:
        l = 1 + O(z2), h = p2;
      default:
        if (b < 1) {
          if (k2 == 123)
            --b;
          else if (k2 == 125 && b++ == 0 && L() == 125)
            continue;
        }
        switch (z2 += d(k2), k2 * b) {
          case 38:
            $ = o > 0 ? 1 : (z2 += "\f", -1);
            break;
          case 44:
            u[f++] = (O(z2) - 1) * $, $ = 1;
            break;
          case 64:
            if (P() === 45)
              z2 += W(N());
            v = P(), o = l = O(g2 = z2 += ae(Q())), k2++;
            break;
          case 45:
            if (p2 === 45 && O(z2) == 2)
              b = 0;
        }
    }
  return t2;
}
function te(e2, r2, a2, c2, t2, s, u, i2, f, o, l) {
  var v = t2 - 1;
  var h = t2 === 0 ? s : [""];
  var p2 = M(h);
  for (var b = 0, w = 0, $ = 0; b < c2; ++b)
    for (var d2 = 0, g2 = A(e2, v + 1, v = k(w = u[b])), m2 = e2; d2 < p2; ++d2)
      if (m2 = x(w > 0 ? h[d2] + " " + g2 : j(g2, /&\f/g, h[d2])))
        f[$++] = m2;
  return I(e2, r2, a2, t2 === 0 ? n : i2, f, o, l);
}
function se(e2, r2, a2) {
  return I(e2, r2, a2, c, d(K()), A(e2, 2, -2), 0);
}
function ue(e2, r2, a2, c2) {
  return I(e2, r2, a2, t, A(e2, 0, c2), A(e2, c2 + 1, -1), c2);
}
function ie(c2, n2) {
  switch (m(c2, n2)) {
    case 5103:
      return a + "print-" + c2 + c2;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return a + c2 + c2;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return a + c2 + r + c2 + e + c2 + c2;
    case 6828:
    case 4268:
      return a + c2 + e + c2 + c2;
    case 6165:
      return a + c2 + e + "flex-" + c2 + c2;
    case 5187:
      return a + c2 + j(c2, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + c2;
    case 5443:
      return a + c2 + e + "flex-item-" + j(c2, /flex-|-self/, "") + c2;
    case 4675:
      return a + c2 + e + "flex-line-pack" + j(c2, /align-content|flex-|-self/, "") + c2;
    case 5548:
      return a + c2 + e + j(c2, "shrink", "negative") + c2;
    case 5292:
      return a + c2 + e + j(c2, "basis", "preferred-size") + c2;
    case 6060:
      return a + "box-" + j(c2, "-grow", "") + a + c2 + e + j(c2, "grow", "positive") + c2;
    case 4554:
      return a + j(c2, /([^-])(transform)/g, "$1" + a + "$2") + c2;
    case 6187:
      return j(j(j(c2, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), c2, "") + c2;
    case 5495:
    case 3959:
      return j(c2, /(image-set\([^]*)/, a + "$1$`$1");
    case 4968:
      return j(j(c2, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + c2 + c2;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return j(c2, /(.+)-inline(.+)/, a + "$1$2") + c2;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (O(c2) - 1 - n2 > 6)
        switch (z(c2, n2 + 1)) {
          case 109:
            if (z(c2, n2 + 4) !== 45)
              break;
          case 102:
            return j(c2, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3$1" + r + (z(c2, n2 + 3) == 108 ? "$3" : "$2-$3")) + c2;
          case 115:
            return ~C(c2, "stretch") ? ie(j(c2, "stretch", "fill-available"), n2) + c2 : c2;
        }
      break;
    case 4949:
      if (z(c2, n2 + 1) !== 115)
        break;
    case 6444:
      switch (z(c2, O(c2) - 3 - (~C(c2, "!important") && 10))) {
        case 107:
          return j(c2, ":", ":" + a) + c2;
        case 101:
          return j(c2, /(.+:)([^;!]+)(;|!.+)?/, "$1" + a + (z(c2, 14) === 45 ? "inline-" : "") + "box$3$1" + a + "$2$3$1" + e + "$2box$3") + c2;
      }
      break;
    case 5936:
      switch (z(c2, n2 + 11)) {
        case 114:
          return a + c2 + e + j(c2, /[svh]\w+-[tblr]{2}/, "tb") + c2;
        case 108:
          return a + c2 + e + j(c2, /[svh]\w+-[tblr]{2}/, "tb-rl") + c2;
        case 45:
          return a + c2 + e + j(c2, /[svh]\w+-[tblr]{2}/, "lr") + c2;
      }
      return a + c2 + e + c2 + c2;
  }
  return c2;
}
function fe(e2, r2) {
  var a2 = "";
  var c2 = M(e2);
  for (var n2 = 0; n2 < c2; n2++)
    a2 += r2(e2[n2], n2, e2, r2) || "";
  return a2;
}
function oe(e2, r2, a2, s) {
  switch (e2.type) {
    case i:
    case t:
      return e2.return = e2.return || e2.value;
    case c:
      return "";
    case p:
      return e2.return = e2.value + "{" + fe(e2.children, s) + "}";
    case n:
      e2.value = e2.props.join(",");
  }
  return O(a2 = fe(e2.children, s)) ? e2.return = e2.value + "{" + a2 + "}" : "";
}
function le(e2) {
  var r2 = M(e2);
  return function(a2, c2, n2, t2) {
    var s = "";
    for (var u = 0; u < r2; u++)
      s += e2[u](a2, c2, n2, t2) || "";
    return s;
  };
}
function ve(e2) {
  return function(r2) {
    if (!r2.root) {
      if (r2 = r2.return)
        e2(r2);
    }
  };
}
function he(c2, s, u, i2) {
  if (c2.length > -1) {
    if (!c2.return)
      switch (c2.type) {
        case t:
          c2.return = ie(c2.value, c2.length);
          break;
        case p:
          return fe([J(c2, {
            value: j(c2.value, "@", "@" + a)
          })], i2);
        case n:
          if (c2.length)
            return q(c2.props, function(n2) {
              switch (y(n2, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return fe([J(c2, {
                    props: [j(n2, /:(read-\w+)/, ":" + r + "$1")]
                  })], i2);
                case "::placeholder":
                  return fe([J(c2, {
                    props: [j(n2, /:(plac\w+)/, ":" + a + "input-$1")]
                  }), J(c2, {
                    props: [j(n2, /:(plac\w+)/, ":" + r + "$1")]
                  }), J(c2, {
                    props: [j(n2, /:(plac\w+)/, e + "input-$1")]
                  })], i2);
              }
              return "";
            });
      }
  }
}
var weakMemoize = function weakMemoize2(func) {
  var cache = new WeakMap();
  return function(arg) {
    if (cache.has(arg)) {
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
  var previous = 0;
  var character = 0;
  while (true) {
    previous = character;
    character = P();
    if (previous === 38 && character === 12) {
      points[index] = 1;
    }
    if (T(character)) {
      break;
    }
    N();
  }
  return R(begin, F);
};
var toRules = function toRules2(parsed, points) {
  var index = -1;
  var character = 44;
  do {
    switch (T(character)) {
      case 0:
        if (character === 38 && P() === 12) {
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(F - 1, points, index);
        break;
      case 2:
        parsed[index] += W(character);
        break;
      case 4:
        if (character === 44) {
          parsed[++index] = P() === 58 ? "&\f" : "";
          points[index] = parsed[index].length;
          break;
        }
      default:
        parsed[index] += d(character);
    }
  } while (character = N());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return V(toRules(U(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i2 = 0, k2 = 0; i2 < rules.length; i2++) {
    for (var j2 = 0; j2 < parentRules.length; j2++, k2++) {
      element.props[k2] = points[i2] ? rules[i2].replace(/&\f/g, parentRules[j2]) : parentRules[j2] + " " + rules[i2];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var defaultStylisPlugins = [he];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node) {
      var dataEmotionAttribute = node.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
      var attrib = node.getAttribute("data-emotion").split(" ");
      for (var i2 = 1; i2 < attrib.length; i2++) {
        inserted[attrib[i2]] = true;
      }
      nodesToHydrate.push(node);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [oe, ve(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = le(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return fe(ce(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var EmotionCacheContext = /* @__PURE__ */ createContext(typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
  key: "css"
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ createContext({});
var getTheme = function getTheme2(outerTheme, theme) {
  if (typeof theme === "function") {
    var mergedTheme = theme(outerTheme);
    return mergedTheme;
  }
  return _extends({}, outerTheme, theme);
};
var createCacheWithTheme = /* @__PURE__ */ weakMemoize(function(outerTheme) {
  return weakMemoize(function(theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider2(props) {
  var theme = useContext(ThemeContext);
  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }
  return /* @__PURE__ */ createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
export {CacheProvider as C, F, N, P, R, StyleSheet as S, ThemeProvider as T, U, V, W, ThemeContext as a, T as b, ce as c, d, fe as f, he as h, le as l, oe as o, ve as v, withEmotionCache as w};
